function SearchSVG({ style, ...props }) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <mask
                id="mask0_3071_391"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="3"
                y="3"
                width="18"
                height="17"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.1865 14.033H15.9765L20.2165 18.1639C20.6265 18.5615 20.6265 19.2112 20.2165 19.6088C19.8065 20.0063 19.1365 20.0063 18.7265 19.6088L14.4765 15.4875V14.7215L14.2065 14.45C12.8065 15.6136 10.8965 16.2148 8.86646 15.8851C6.08646 15.4294 3.86646 13.1797 3.52646 10.4645C3.00646 6.36269 6.56646 2.91057 10.7965 3.41481C13.5965 3.74451 15.9165 5.89724 16.3865 8.593C16.7265 10.5615 16.1065 12.4136 14.9065 13.7712L15.1865 14.033ZM5.47646 9.66936C5.47646 12.0839 7.48646 14.033 9.97646 14.033C12.4665 14.033 14.4765 12.0839 14.4765 9.66936C14.4765 7.25481 12.4665 5.30572 9.97646 5.30572C7.48646 5.30572 5.47646 7.25481 5.47646 9.66936Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_3071_391)">
                <rect
                    width="24"
                    height="23.2727"
                    fill="var(--keel-navy)"
                    style={style}
                />
            </g>
        </svg>
    );
}

export default SearchSVG;
